/**
 * Сервис по работе с url
 */

export default class UrlService {

    /**
     * Получить значения параметра по имени
     * @param name
     * @param entryUrl
     */
    static getParamValueByName(name: string, entryUrl: string): string|null
    {
        const url = new URL(entryUrl);

        return url.searchParams.get(name) ?? null;
    }

    /**
     * получить строку query параметров
     * @param paramsData
     */
    static getQueryString(paramsData: JQuery.NameValuePair[]): string
    {
        const params: Array<Array<string>> = [];

        paramsData.forEach((item) => {
            if ((item.value ?? null ) === null || item.value === '') {
                return;
            }

            params.push([item.name, item.value]);
        });

        return params.map(el => `${el[0]}=${el[1]}`).join('&');
    }

    /**
     * Установить параметры в url
     * @param paramsData
     */
    static setUrlParams(paramsData: JQuery.NameValuePair[]): void
    {
        history.pushState(null, '', `?${UrlService.getQueryString(paramsData)}`);
    }

    /**
     * Удаляем все параметры из url
     */
    static clearUrlParams(): void
    {
        history.replaceState(null, '', window.location.pathname);
    }

    /**
     * Стираем определенный параметр из url
     * @param param
     */
    static deleteUrlParam(param: string): void {
        const currentUrl = new URL(window.location.href);

        currentUrl.searchParams.delete(param);

        const newUrl = currentUrl.toString();

        history.replaceState({}, '', newUrl);
    }

    /**
     * Добавляем или заменяем переданный параметр
     * @param param
     * @param value
     */
    static setOrReplaceParam(param: string, value: string): void {
        const currentUrl = new URL(window.location.href);

        currentUrl.searchParams.set(param, value);

        const newUrl = currentUrl.toString();

        history.replaceState({}, '', newUrl);
    }
}

